import axios from 'axios'

const setupAxios = () => {
    axios.interceptors.response.use(undefined, (err) => {

      if (err.response?.status === 401 && !err.config.url.includes('director/admin-auth/check')) {
        return window.location.replace(`${window.location.origin}/login?redirect=${window.location.pathname}${window.location.search}`)
      }
        const { config } = err;
        if (!config || !config.retry) {
      
          return Promise.reject(err)
        }
      
        config.retry -= 1
        const delayRetryRequest = new Promise((resolve) => {
          setTimeout(() => {
            /*@ts-ignore*/
            resolve();
          }, config.retryDelay)
        });
        return delayRetryRequest.then(() => axios(config));
      })
}

export default setupAxios
